import { Routes, Route } from 'react-router-dom'
import type { RouteObject } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { ThemeProvider } from '@/contexts/ThemeContext'
import Home from '@/pages/Home'
import AdminLogin from '@/pages/AdminLogin'
import Dashboard from '@/pages/Dashboard'
import ArticlePage from '@/pages/ArticlePage'
import GoogleAnalytics from '@/components/GoogleAnalytics'

// Exportado para uso no prerender.tsx
export const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/artigo/:slug', element: <ArticlePage /> },
  { path: '/admin/login', element: <AdminLogin /> },
  { path: '/admin/*', element: <Dashboard /> },
]

export default function App() {
  return (
    <ThemeProvider>
      {/* Toasts globais */}
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: { fontSize: '14px', maxWidth: '380px' },
          success: { iconTheme: { primary: '#dc2626', secondary: '#fff' } },
          error: { iconTheme: { primary: '#dc2626', secondary: '#fff' } },
        }}
      />

      <GoogleAnalytics />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/artigo/:slug" element={<ArticlePage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        {/*
          /admin/* é gerida pelo Dashboard.
          A protecção real é feita dentro do Dashboard (aguarda isLoading antes de redirecionar)
          e dentro de cada ProtectedRoute nas sub-rotas sensíveis.
        */}
        <Route path="/admin/*" element={<Dashboard />} />
      </Routes>
    </ThemeProvider>
  )
}
